import type { TFunction } from 'i18next';

import type { PasswordRuleState } from '../../domain/newPasswordRules';

export const passwordRuleText = (t: TFunction, state: PasswordRuleState, min: number): string => {
  switch (state) {
    case 'failed':
      return t('passcodeAuth.passwordForm.ruleFailed', 'At least {{min}} characters, and both must match.', { min });
    case 'met':
      return t('passcodeAuth.passwordForm.ruleMet', 'Done: at least {{min}} characters, and both match.', { min });
    case 'pending':
      return t('passcodeAuth.passwordForm.rule', 'At least {{min}} characters.', { min });
  }
};
